import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyA-SJOHr_BbaX9UcmLnIjPrKfUpMOCaBvA",
    authDomain: "chant-demo.firebaseapp.com",
    databaseURL: "https://chant-demo.firebaseio.com",
    projectId: "chant-demo",
    storageBucket: "chant-demo.appspot.com",
    messagingSenderId: "1034388033702",
    appId: "1:1034388033702:web:aa28b65d2b64498559a467",
    measurementId: "G-4NJ56BZZWV"
};

export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore();

const { Timestamp, GeoPoint, FieldValue } = firebase.firestore
export { Timestamp, GeoPoint, FieldValue }
